import { useEffect, useState } from 'react';

const MOBILE_QUERY = '(max-width: 767px)';

export const useResponsiveLayout = () => {
  const getMatches = () => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return false;
    }
    return window.matchMedia(MOBILE_QUERY).matches;
  };

  const [isMobile, setIsMobile] = useState<boolean>(getMatches);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return;
    }

    const mediaQueryList = window.matchMedia(MOBILE_QUERY);
    const listener = (event: MediaQueryListEvent) => setIsMobile(event.matches);

    mediaQueryList.addEventListener('change', listener);
    setIsMobile(mediaQueryList.matches);

    return () => mediaQueryList.removeEventListener('change', listener);
  }, []);

  return { isMobile };
};
